import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Component/Main";
import Checkout from "./Component/CheckOut";
import PaySuccess from "./Component/SuccessPay";
import PayFailure from "./Component/FailedPay";
import { BASE_URL } from "./constans/ApiEndpointConstants";
import queryString from "query-string";
import LocalStorageUtil from "./utils/localStorageUtil";
import * as GetPixelAPI from "./apis/GetPixelAPI";
import ReactPixel from "react-facebook-pixel";
import About from "./Component/header/About";
import Shop from "./Component/header/Shop";
import Labresultaten from "./Component/header/Labresultaten";
import Calculator from "./Component/header/ Calculator";
import HelpCenter from "./Component/header/HelpCenter";
import ProductDetails from "./Component/ProductDetails";
import { CartProvider } from "./Component/common/CartContext";
import { SiteSettingsProvider } from "./Component/common/SiteSettingsContext";
import Cart from "./Component/Cart";
import Terms from "./Component/footer/Terms";
import Refunds from "./Component/footer/Refunds";
import Privacy from "./Component/footer/Privacy";
import Contact from "./Component/footer/Contact";
import Bulk from "./Component/footer/Bulk";
import Partner from "./Component/footer/Partner";
import Account from "./Component/header/Account";
import Shipping from "./Component/footer/Shipping";

import { HelmetProvider } from 'react-helmet-async';
import MetaUpdater from './Component/common/MetaUpdater';
import WhatsAppFloat from "./Component/common/WhatsAppFloat";

function App() {
  useEffect(() => {
    const url = BASE_URL;
    const strippedUrl = url.replace(/^https?:\/\//, "");

    const location = window.location.href;
    const result = location.substring(location.indexOf("?"));
    const arr = queryString.parse(result);
    let ad = arr.ad;
    if (!ad || ad.trim() === "") {
      const cachedAd = LocalStorageUtil.getAd();
      if (cachedAd && cachedAd.trim() !== "") {
        ad = cachedAd;
      } else {
        ad = "PurityBase";
      }
    }
    LocalStorageUtil.saveAd(ad);

    GetPixelAPI.getpixel(strippedUrl).then((res) => {
      const data = res.data.data;

      console.log(data);

      if (data && data.pixel) {
        const pixelId = data.pixel;

        // 使用 react-facebook-pixel 初始化
        ReactPixel.init(
          pixelId,
          {},
          {
            debug: true,
            autoConfig: false, // 禁用自动配置
          }
        );
        ReactPixel.pageView();

        // 存储 Pixel 相关数据
        // localStorage.setItem("tgid", data.tgid?.toString() || null);
        // localStorage.setItem("fbqToken", data.fbqToken?.toString());
        // localStorage.setItem("pixel", data.pixel?.toString() || null);
        // localStorage.setItem("stusername", data.stusername?.toString() || null);
        LocalStorageUtil.saveTgid(data.tgid);
        LocalStorageUtil.savePixel(data.pixel);
        LocalStorageUtil.saveFbqToken(data.fbqToken);
        LocalStorageUtil.saveStUsername(data.stusername);
        LocalStorageUtil.saveGroupId(data.groupid);
      }
    });
  }, []);
  return (
    <CartProvider>
      <HelmetProvider>
        <Router>
          <SiteSettingsProvider>
            <MetaUpdater />
            <WhatsAppFloat />
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/shopDetails/:name_id" element={<ProductDetails />} />
              <Route path="/help" element={<HelpCenter />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/lab" element={<Labresultaten />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/about" element={<About />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/paysuccess" element={<PaySuccess />} />
              <Route path="/payfial" element={<PayFailure />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refund" element={<Refunds />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/bulk" element={<Bulk />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="/account" element={<Account />} />
            </Routes>
          </SiteSettingsProvider>
        </Router>
      </HelmetProvider>
    </CartProvider>
  );
}

export default App;
